import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, VERSION, ViewChild, forwardRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule  } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { DataService } from '../../services/data/data.service';
import { ClaimantService } from '../../services/claimant/claimant.service';
import { Claimant } from '../../models/claimant';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { BsDatepickerConfig, BsDatepickerModule } from "ngx-bootstrap/datepicker";


@Component({
  selector: 'app-file',
  templateUrl: './file.html',
  styleUrls: ['./file.css'],
  imports: [ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, MatStepperModule, BsDatepickerModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class File implements OnInit {
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('name') name: ElementRef;

  purchasesDatePickerConfig: Partial<BsDatepickerConfig>;
  distributionsDatePickerConfig: Partial<BsDatepickerConfig>;
  salesDatePickerConfig: Partial<BsDatepickerConfig>;

  clicked: boolean = false;
  submitClicked: boolean = false;
  showMessage: boolean = false;
  submitted: boolean = false;
  isLinear: boolean = false; // Set to true for linear progression
  showDivForNonUS: boolean = false;
  showDivProvince: boolean = false;
  showDivStateZip: boolean = true;
  showSSNTINRow: boolean = false;
  showDivlast4SSN: boolean = false;
  showDivTIN: boolean = false;
  showDivForUS: boolean = false;
  showDivOtherClaimantAccountType: boolean = false;
  changed = false;
  stepOneForm: FormGroup;
  stepTwoForm: FormGroup;
  stepThreeForm: FormGroup;
  stepFiveForm: FormGroup;
  stepFourForm: FormGroup;
  claimStartTime: string;
  claimEndTime: string;
  stepSixForm: FormGroup;
  response: string | undefined;
  dateLoaded: Date;
  showDivSubmittalErrorMessage: boolean = false;
  allStates: any = [];
  allCusips: any = [];
  allCountries: any = [];
  allClaimantAccountTypes: any = [];
  saleList: any = [];
  purchaseList: any = [];
  openingList: any = [];
  lookbackList: any = [];
  closingList: any = [];
  lookbackNoteList: any = [];
  purchaseNoteList: any = [];
  saleNoteList: any = [];
  openingNoteList: any = [];
  closingNoteList: any = [];
  showSubmittalErrorWarning: boolean = false;
  distributionList: any = [];
  claimDetailList: any = [];
  supportingDocuments: File[] = [];

  public claimant: Claimant;
  public errorMessage: string = '';
  public showError: boolean;
  public submittedClaim: Claimant;

  validation_ClassMembersErrorMessage = {
    classMemberName: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "Field must be at least 2 characters" },
      { type: "maxlength", message: "Field cannot be more than 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    classMemberFEIN: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "Field must be at least 9 characters" },
      { type: "maxlength", message: "Field cannot be more than 9 characters" },
      { type: "pattern", message: "Only use numbers" }
    ],
  };

  validation_ClassMemberPaidAmountsErrorMessage = {
    classMemberName: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "Field must be at least 2 characters" },
      { type: "maxlength", message: "Field cannot be more than 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    classMemberPaidAmount: [
      { type: 'required', message: 'This Field is required' },
      { type: "maxlength", message: "Field cannot be more than 15 digits" },
      { type: "pattern", message: "Only use numbers with optional period (.) and up to 4 digits past decimal" }
    ],
  };

  constructor(private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private dataService: DataService, 
    private router: Router,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef, 
    private claimantService: ClaimantService) { }


  ngOnInit() {
    this.loadAllStates();
    this.loadAllCountries();
    this.loadAllClaimantAccountTypes();
    this.loadAllCusips();
    this.dateLoaded = new Date();
    this.claimStartTime = this.dateLoaded.toLocaleTimeString();

    this.purchasesDatePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        maxDate: new Date(2013, 11, 18),
        dateInputFormat: 'MM/DD/YYYY',
      });
    this.distributionsDatePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        maxDate: new Date(2013, 11, 18),
        dateInputFormat: 'MM/DD/YYYY',
      });
    this.salesDatePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        maxDate: new Date(2013, 11, 18),
        dateInputFormat: 'MM/DD/YYYY'
      });

    this.stepOneForm = this.fb.group({
    });
    this.stepTwoForm = this.fb.group({
      optTINSSN: [''],
      last4SSN: [''],
      tin: [''],
      name1: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      name2: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      name3: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      name4: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      emailAddress: ['', Validators.compose([Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      street1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      street2: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      country: ['', Validators.compose([Validators.required])],
      province: [''],
      postalCode: [''],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      primaryPhone: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      secondaryPhone: ['', Validators.compose([Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      primaryPhoneType: ['', Validators.compose([Validators.required])],
      secondaryPhoneType: [''],
      accountNumber: ['', Validators.compose([Validators.maxLength(12), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9]+$")])],
      claimantAccountType: ['', Validators.compose([Validators.required])],
      otherClaimantAccountType: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
    });
    this.stepTwoForm.get('secondaryPhone')?.valueChanges.subscribe(value => {
      const dropdownControl = this.stepTwoForm.get('secondaryPhoneType');
      if (value) {
        dropdownControl?.setValidators([Validators.required]);
      } else {
        dropdownControl?.clearValidators();
      }
      dropdownControl?.updateValueAndValidity();
    });
    this.stepThreeForm = this.fb.group({
      purchasesTradeDate: [''],
      purchasesQuantity: [''],
      purchasesCusip: [''],
      purchasesPricePerShare: [''],
      purchasesTotalPrice: [''],

      distributionsTradeDate: [''],
      distributionsQuantity: [''],
      distributionsCusip: [''],
      distributionsPricePerShare: [''],
      distributionsTotalPrice: [''],

      salesTradeDate: [''],
      salesQuantity: [''],
      salesCusip: [''],
      salesPricePerShare: [''],
      salesTotalPrice: [''],

      closingQuantity: [''],
      closingCusip: [''],
    });
    this.stepFourForm = this.fb.group({
    });
    this.stepFiveForm = this.fb.group({
      irsBackUpWithHolding: [false],
      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      jointClaimantSignature: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      signingOnBehalfCapacity: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      helperCapacity: ['', Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])]

    });
  }

  loadAllStates() {
    this.httpClient.get("assets/States.json").subscribe(data => {
      this.allStates = data;
    })
  }

  loadAllCountries() {
    this.httpClient.get("assets/Countries.json").subscribe(data => {
      this.allCountries = data;
    })
  }

  loadAllClaimantAccountTypes() {
    this.httpClient.get("assets/ClaimantAccountTypes.json").subscribe(data => {
      this.allClaimantAccountTypes = data;
    })
  }

  loadAllCusips() {
    this.httpClient.get("assets/Cusips.json").subscribe(data => {
      this.allCusips = data;
    })
  }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  // convenience getter for easy access to form fields
  get f() { return this.stepTwoForm.controls; }
  get g() { return this.stepThreeForm.controls; }
  get h() { return this.stepFiveForm.controls; }

  done() {
    this.stepper.selected.completed = false;
    this.stepper.selected.editable = true;
    this.stepper.next();
    this.submitted = false;
  }

  edit() {
    this.stepper.selected.completed = false;
    this.stepper.selected.editable = true;
    this.stepper.previous();
  }

  saveAndValidateStepTwo() {
    // stop here if form is invalid
    if (this.stepTwoForm.invalid) {
      return;
    }


    //this.stepper.selected.completed = false;
    //this.stepper.selected.editable = true;  
    /*this.submitted = false;*/
    let test = this.stepTwoForm.value;
    this.dataService.stepTwoSharedData = test;
    this.stepper.next();
  }

  saveAndValidateStepThree() {

    // stop here if form is invalid
    if (this.stepThreeForm.invalid) {
      return;
    }

    let one = this.stepThreeForm.get('purchasesTradeDate').value;
    var two = this.stepThreeForm.get('purchasesQuantity').value;
    var three = this.stepThreeForm.get('purchasesCusip').value;
    let five = this.stepThreeForm.get('purchasesPricePerShare').value;
    var six = this.stepThreeForm.get('purchasesTotalPrice').value;

    let seven = this.stepThreeForm.get('distributionsTradeDate').value;
    var eight = this.stepThreeForm.get('distributionsQuantity').value;
    var nine = this.stepThreeForm.get('distributionsCusip').value;
    let eleven = this.stepThreeForm.get('distributionsPricePerShare').value;
    var twelve = this.stepThreeForm.get('distributionsTotalPrice').value;

    let thirteen = this.stepThreeForm.get('salesTradeDate').value;
    var fourteen = this.stepThreeForm.get('salesQuantity').value;
    var fifteen = this.stepThreeForm.get('salesCusip').value;
    let seventeen = this.stepThreeForm.get('salesPricePerShare').value;
    var eighteen = this.stepThreeForm.get('salesTotalPrice').value;

    let nineteen = this.stepThreeForm.get('closingQuantity').value;
    var twenty = this.stepThreeForm.get('closingCusip').value;

    if ((one !== '') || (two !== '') || (three !== '') || (five !== '') || (six !== '') || (seven !== '') || (eight !== '') || (nine !== '') 
      || (eleven !== '') || (twelve !== '') || (thirteen !== '') || (fourteen !== '') || (fifteen !== '') || (seventeen !== '') || (eighteen !== '') ||
      (nineteen !== '') || (twenty !== '')) {
      this.showMessage = true;
      return;
    }
    if ((one === '') || (two === '') || (three === '') || (five === '') || (six === '') || (seven === '') || (eight === '') || (nine === '') 
      || (eleven === '') || (twelve === '') || (thirteen === '') || (fourteen === '') || (fifteen === '') || (seventeen === '') || (eighteen === '') ||
      (nineteen === '') || (twenty === '') ) {
      this.showMessage = false;
    }

    this.dataService.stepThreeSharedDataPurchases = this.purchaseList;
    this.dataService.stepThreeSharedDataDistributions = this.distributionList;
    this.dataService.stepThreeSharedDataSales = this.saleList;
    this.dataService.stepThreeSharedDataClosing = this.closingList;

    this.stepper.next();
  }

  saveAndValidateStepFour() {
    //this.stepper.selected.completed = false;
    //this.stepper.selected.editable = true;  
    /*this.submitted = false;*/
    let test = this.supportingDocuments;
    this.dataService.stepFourSharedData = test;
    this.stepper.next();
  }

  getPhoneType2Value() {
    this.changed = true;
    const secondaryPhoneType = this.stepTwoForm.get('secondaryPhoneType')?.value;

    if (secondaryPhoneType !== '') {
      this.stepTwoForm.get('secondaryPhone').setValidators(Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")]));
    } else {
      this.stepTwoForm.get('secondaryPhone').clearValidators();
    }
    this.stepTwoForm.get('secondaryPhone').updateValueAndValidity();
  }


  getCountryValue($event) {
    // if you need the event source and value it can be accessed.
    if ($event.target.value !== 'United States') {
      this.showDivForNonUS = true;
      this.showDivForUS = false;
      //this.showDivStateZip = false;
      this.showSSNTINRow = false;

      this.stepTwoForm.get('state').clearValidators();
      this.stepTwoForm.get('state').updateValueAndValidity();
      this.stepTwoForm.get('state').reset();
      this.stepTwoForm.get('zip').clearValidators();
      this.stepTwoForm.get('zip').updateValueAndValidity();
      this.stepTwoForm.get('zip').reset();
      this.stepTwoForm.get('optTINSSN').clearValidators();
      this.stepTwoForm.get('optTINSSN').updateValueAndValidity();
      this.stepTwoForm.get('optTINSSN').reset();
      this.stepTwoForm.get('tin').clearValidators();
      this.stepTwoForm.get('tin').updateValueAndValidity();
      this.stepTwoForm.get('tin').reset();
      this.stepTwoForm.get('last4SSN').clearValidators();
      this.stepTwoForm.get('last4SSN').updateValueAndValidity();
      this.stepTwoForm.get('last4SSN').reset();
      this.stepTwoForm.get('city').reset();
      this.stepTwoForm.get('postalCode').setValidators(Validators.compose([Validators.maxLength(10)]));
      this.stepTwoForm.get('province').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    }

    if ($event.target.value === 'United States') {
      this.showDivForUS = true;
      this.showDivForNonUS = false;

      this.showSSNTINRow = true;
      this.stepTwoForm.get('city').reset();
      this.stepTwoForm.get('province').reset();
      this.stepTwoForm.get('postalCode').reset();

      this.stepTwoForm.get('optTINSSN').reset();
      this.stepTwoForm.get('last4SSN').reset();
      this.stepTwoForm.get('tin').reset();

      this.stepTwoForm.get('province').clearValidators();
      this.stepTwoForm.get('province').updateValueAndValidity();
      this.stepTwoForm.get('postalCode').clearValidators();
      this.stepTwoForm.get('postalCode').updateValueAndValidity();
      this.stepTwoForm.get('optTINSSN').clearValidators();
      this.stepTwoForm.get('optTINSSN').updateValueAndValidity();
      this.stepTwoForm.get('tin').clearValidators();
      this.stepTwoForm.get('tin').updateValueAndValidity();

      this.stepTwoForm.get('tin').setValidators(Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern("^[0-9]+$")]));
      this.stepTwoForm.get('optTINSSN').setValidators(Validators.compose([Validators.required]));
      this.stepTwoForm.get('last4SSN').setValidators(Validators.compose([Validators.required, Validators.maxLength(4), Validators.minLength(4), Validators.pattern("^[0-9]+$")]));
      this.stepTwoForm.get('city').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('state').setValidators(Validators.compose([Validators.required]));
      this.stepTwoForm.get('zip').setValidators(Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")]));

    }
  }

  getOptTINSSNValue($event) {
    // Access the event source and value.
    if ($event.target.value === 'Last Four Of SSN') {
      this.showDivlast4SSN = true;
      this.showDivTIN = false;
      this.stepTwoForm.get('last4SSN').setValidators(Validators.compose([Validators.required, Validators.maxLength(4), Validators.minLength(4), Validators.pattern("^[0-9]+$")]));
      this.stepTwoForm.get('tin').clearValidators();
      this.stepTwoForm.get('tin').updateValueAndValidity();
      this.stepTwoForm.get('tin').reset();
    }

    if ($event.target.value === 'Tax Identification Number') {
      this.showDivTIN = true;
      this.showDivlast4SSN = false;
      this.stepTwoForm.get('tin').setValidators(Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern("^[0-9]+$")]));
      this.stepTwoForm.get('last4SSN').clearValidators();
      this.stepTwoForm.get('last4SSN').updateValueAndValidity();
      this.stepTwoForm.get('last4SSN').reset();
    }
  }

  getClaimantAccounTypeValue($event) {
    // Access the event source and value.
    if ($event.target.value === 'Other') {
      this.showDivOtherClaimantAccountType = true;
      this.stepTwoForm.get('otherClaimantAccountType').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    }

    if ($event.target.value !== 'Other') {
      this.showDivOtherClaimantAccountType = false;
      this.stepTwoForm.get('otherClaimantAccountType').clearValidators();
      this.stepTwoForm.get('otherClaimantAccountType').updateValueAndValidity();
      this.stepTwoForm.get('otherClaimantAccountType').reset();
    }
  }

  onBlur(event) {
    if (event.target.value !== '')
      event.target.value = parseFloat(event.target.value).toFixed(2)
  }

  // Remove the second element and so on
  removeAllExceptFirst(formArray: FormArray): void {
    while (formArray.length > 1) {
      formArray.removeAt(0);
    }
  }

  removeTable() {
    if (this.tableRef) {
      this.tableRef.nativeElement.remove();
    }
  }

  getBeneficialOwnerTypeValue($event) {
    // Access the event source and value.
    if ($event.target.value === 'Other') {
      this.showDivOtherClaimantAccountType = true;
      this.stepTwoForm.get('otherBeneficialOwnerType').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    }

    if ($event.target.value !== 'Other') {
      this.showDivOtherClaimantAccountType = false;
      this.stepTwoForm.get('otherBeneficialOwnerType').clearValidators();
      this.stepTwoForm.get('otherBeneficialOwnerType').updateValueAndValidity();
      this.stepTwoForm.get('otherBeneficialOwnerType').reset();
    }
  }

  clearPurchasesData() {
    this.stepThreeForm.get('purchasesTradeDate').setValue('');
    this.stepThreeForm.get('purchasesTradeDate').clearValidators();
    this.stepThreeForm.get('purchasesTradeDate').updateValueAndValidity();
    this.stepThreeForm.get('purchasesTradeDate').markAsUntouched();
    this.stepThreeForm.get('purchasesTradeDate').markAsPristine();

    this.stepThreeForm.get('purchasesQuantity').setValue('');
    this.stepThreeForm.get('purchasesQuantity').clearValidators();
    this.stepThreeForm.get('purchasesQuantity').updateValueAndValidity();
    this.stepThreeForm.get('purchasesQuantity').markAsUntouched();
    this.stepThreeForm.get('purchasesQuantity').markAsPristine();

    this.stepThreeForm.get('purchasesCusip').setValue('');
    this.stepThreeForm.get('purchasesCusip').clearValidators();
    this.stepThreeForm.get('purchasesCusip').updateValueAndValidity();
    this.stepThreeForm.get('purchasesCusip').markAsUntouched();
    this.stepThreeForm.get('purchasesCusip').markAsPristine();

    this.stepThreeForm.get('purchasesPricePerShare').setValue('');
    this.stepThreeForm.get('purchasesPricePerShare').clearValidators();
    this.stepThreeForm.get('purchasesPricePerShare').updateValueAndValidity();
    this.stepThreeForm.get('purchasesPricePerShare').markAsUntouched();
    this.stepThreeForm.get('purchasesPricePerShare').markAsPristine();

    this.stepThreeForm.get('purchasesTotalPrice').setValue('');
    this.stepThreeForm.get('purchasesTotalPrice').clearValidators();
    this.stepThreeForm.get('purchasesTotalPrice').updateValueAndValidity();
    this.stepThreeForm.get('purchasesTotalPrice').markAsUntouched();
    this.stepThreeForm.get('purchasesTotalPrice').markAsPristine();

    this.showMessage = false;

  }

  addPurchasesData() {
    this.clicked = true;
    this.stepThreeForm.get('purchasesTradeDate')?.setValidators([Validators.required]);
    this.stepThreeForm.get('purchasesTradeDate')?.updateValueAndValidity();

    this.stepThreeForm.get('purchasesQuantity')?.setValidators([Validators.required, Validators.maxLength(11), Validators.pattern("\\d{0,6}(?:[.]\\d{1,4})?$")]);
    this.stepThreeForm.get('purchasesQuantity')?.updateValueAndValidity();

    this.stepThreeForm.get('purchasesCusip')?.setValidators([Validators.required]);
    this.stepThreeForm.get('purchasesCusip')?.updateValueAndValidity();

    this.stepThreeForm.get('purchasesPricePerShare')?.setValidators(Validators.compose([Validators.required, Validators.maxLength(11), Validators.pattern("\\d{0,6}(?:[.]\\d{1,4})?$")]));
    this.stepThreeForm.get('purchasesPricePerShare')?.updateValueAndValidity();

    this.stepThreeForm.get('purchasesTotalPrice')?.setValidators(Validators.compose([Validators.required, Validators.maxLength(11), Validators.pattern("\\d{0,6}(?:[.]\\d{1,4})?$")]));
    this.stepThreeForm.get('purchasesTotalPrice')?.updateValueAndValidity();

    if (this.stepThreeForm.get('purchasesTradeDate').invalid || this.stepThreeForm.get('purchasesQuantity').invalid || this.stepThreeForm.get('purchasesCusip').invalid 
      || this.stepThreeForm.get('purchasesPricePerShare').invalid || this.stepThreeForm.get('purchasesTotalPrice').invalid) {
      return;
    }

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    };

    let tradeDate = this.stepThreeForm.get('purchasesTradeDate').value.toLocaleDateString("en-us", options);
    let pl = new Array();

    pl = [{
      TradeType: 'P',
      SecurityType: 'Trust Certificate',
      TradeDate: tradeDate,
      Quantity: this.stepThreeForm.get('purchasesQuantity').value,
      Cusip: this.stepThreeForm.get('purchasesCusip').value,
      PricePerShare: this.stepThreeForm.get('purchasesPricePerShare').value,
      TotalPrice: this.stepThreeForm.get('purchasesTotalPrice').value,
    }];

    for (let i = 0; i < pl.length; i++) {
      this.purchaseList.push(pl[i]);
    }
    this.stepThreeForm.get('purchasesTradeDate').setValue('');
    this.stepThreeForm.get('purchasesTradeDate').clearValidators();
    this.stepThreeForm.get('purchasesTradeDate').updateValueAndValidity();
    this.stepThreeForm.get('purchasesTradeDate').markAsUntouched();
    this.stepThreeForm.get('purchasesTradeDate').markAsPristine();

    this.stepThreeForm.get('purchasesQuantity').setValue('');
    this.stepThreeForm.get('purchasesQuantity').clearValidators();
    this.stepThreeForm.get('purchasesQuantity').updateValueAndValidity();
    this.stepThreeForm.get('purchasesQuantity').markAsUntouched();
    this.stepThreeForm.get('purchasesQuantity').markAsPristine();

    this.stepThreeForm.get('purchasesCusip').setValue('');
    this.stepThreeForm.get('purchasesCusip').clearValidators();
    this.stepThreeForm.get('purchasesCusip').updateValueAndValidity();
    this.stepThreeForm.get('purchasesCusip').markAsUntouched();
    this.stepThreeForm.get('purchasesCusip').markAsPristine();

    this.stepThreeForm.get('purchasesPricePerShare').setValue('');
    this.stepThreeForm.get('purchasesPricePerShare').clearValidators();
    this.stepThreeForm.get('purchasesPricePerShare').updateValueAndValidity();
    this.stepThreeForm.get('purchasesPricePerShare').markAsUntouched();
    this.stepThreeForm.get('purchasesPricePerShare').markAsPristine();

    this.stepThreeForm.get('purchasesTotalPrice').setValue('');
    this.stepThreeForm.get('purchasesTotalPrice').clearValidators();
    this.stepThreeForm.get('purchasesTotalPrice').updateValueAndValidity();
    this.stepThreeForm.get('purchasesTotalPrice').markAsUntouched();
    this.stepThreeForm.get('purchasesTotalPrice').markAsPristine();

    this.showMessage = false;
    this.clicked = false;

    /* (<FormArray>this.stepThreeForm.get('purchases')).push(this.newPurchase());*/
  }

  clearDistributionsData() {
    this.stepThreeForm.get('distributionsTradeDate').setValue('');
    this.stepThreeForm.get('distributionsTradeDate').clearValidators();
    this.stepThreeForm.get('distributionsTradeDate').updateValueAndValidity();
    this.stepThreeForm.get('distributionsTradeDate').markAsUntouched();
    this.stepThreeForm.get('distributionsTradeDate').markAsPristine();

    this.stepThreeForm.get('distributionsQuantity').setValue('');
    this.stepThreeForm.get('distributionsQuantity').clearValidators();
    this.stepThreeForm.get('distributionsQuantity').updateValueAndValidity();
    this.stepThreeForm.get('distributionsQuantity').markAsUntouched();
    this.stepThreeForm.get('distributionsQuantity').markAsPristine();

    this.stepThreeForm.get('distributionsCusip').setValue('');
    this.stepThreeForm.get('distributionsCusip').clearValidators();
    this.stepThreeForm.get('distributionsCusip').updateValueAndValidity();
    this.stepThreeForm.get('distributionsCusip').markAsUntouched();
    this.stepThreeForm.get('distributionsCusip').markAsPristine();

    this.stepThreeForm.get('distributionsPricePerShare').setValue('');
    this.stepThreeForm.get('distributionsPricePerShare').clearValidators();
    this.stepThreeForm.get('distributionsPricePerShare').updateValueAndValidity();
    this.stepThreeForm.get('distributionsPricePerShare').markAsUntouched();
    this.stepThreeForm.get('distributionsPricePerShare').markAsPristine();

    this.stepThreeForm.get('distributionsTotalPrice').setValue('');
    this.stepThreeForm.get('distributionsTotalPrice').clearValidators();
    this.stepThreeForm.get('distributionsTotalPrice').updateValueAndValidity();
    this.stepThreeForm.get('distributionsTotalPrice').markAsUntouched();
    this.stepThreeForm.get('distributionsTotalPrice').markAsPristine();

    this.showMessage = false;

  }

  addDistributionsData() {
    this.clicked = true;
    this.stepThreeForm.get('distributionsTradeDate')?.setValidators([Validators.required]);
    this.stepThreeForm.get('distributionsTradeDate')?.updateValueAndValidity();

    this.stepThreeForm.get('distributionsQuantity')?.setValidators([Validators.required, Validators.maxLength(11), Validators.pattern("\\d{0,6}(?:[.]\\d{1,4})?$")]);
    this.stepThreeForm.get('distributionsQuantity')?.updateValueAndValidity();

    this.stepThreeForm.get('distributionsCusip')?.setValidators([Validators.required]);
    this.stepThreeForm.get('distributionsCusip')?.updateValueAndValidity();

    this.stepThreeForm.get('distributionsPricePerShare')?.setValidators(Validators.compose([Validators.required, Validators.maxLength(11), Validators.pattern("\\d{0,6}(?:[.]\\d{1,4})?$")]));
    this.stepThreeForm.get('distributionsPricePerShare')?.updateValueAndValidity();

    this.stepThreeForm.get('distributionsTotalPrice')?.setValidators(Validators.compose([Validators.required, Validators.maxLength(11), Validators.pattern("\\d{0,6}(?:[.]\\d{1,4})?$")]));
    this.stepThreeForm.get('distributionsTotalPrice')?.updateValueAndValidity();

    if (this.stepThreeForm.get('distributionsTradeDate').invalid || this.stepThreeForm.get('distributionsQuantity').invalid || this.stepThreeForm.get('distributionsCusip').invalid 
      || this.stepThreeForm.get('distributionsPricePerShare').invalid || this.stepThreeForm.get('distributionsTotalPrice').invalid) {
      return;
    }

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    };

    let tradeDate = this.stepThreeForm.get('distributionsTradeDate').value.toLocaleDateString("en-us", options);
    let dl = new Array();

    dl = [{
      TradeType: 'D',
      SecurityType: 'Trust Certificate',
      TradeDate: tradeDate,
      Quantity: this.stepThreeForm.get('distributionsQuantity').value,
      Cusip: this.stepThreeForm.get('distributionsCusip').value,
      PricePerShare: this.stepThreeForm.get('distributionsPricePerShare').value,
      TotalPrice: this.stepThreeForm.get('distributionsTotalPrice').value,
    }];

    for (let i = 0; i < dl.length; i++) {
      this.distributionList.push(dl[i]);
    }
    this.stepThreeForm.get('distributionsTradeDate').setValue('');
    this.stepThreeForm.get('distributionsTradeDate').clearValidators();
    this.stepThreeForm.get('distributionsTradeDate').updateValueAndValidity();
    this.stepThreeForm.get('distributionsTradeDate').markAsUntouched();
    this.stepThreeForm.get('distributionsTradeDate').markAsPristine();

    this.stepThreeForm.get('distributionsQuantity').setValue('');
    this.stepThreeForm.get('distributionsQuantity').clearValidators();
    this.stepThreeForm.get('distributionsQuantity').updateValueAndValidity();
    this.stepThreeForm.get('distributionsQuantity').markAsUntouched();
    this.stepThreeForm.get('distributionsQuantity').markAsPristine();

    this.stepThreeForm.get('distributionsCusip').setValue('');
    this.stepThreeForm.get('distributionsCusip').clearValidators();
    this.stepThreeForm.get('distributionsCusip').updateValueAndValidity();
    this.stepThreeForm.get('distributionsCusip').markAsUntouched();
    this.stepThreeForm.get('distributionsCusip').markAsPristine();

    this.stepThreeForm.get('distributionsPricePerShare').setValue('');
    this.stepThreeForm.get('distributionsPricePerShare').clearValidators();
    this.stepThreeForm.get('distributionsPricePerShare').updateValueAndValidity();
    this.stepThreeForm.get('distributionsPricePerShare').markAsUntouched();
    this.stepThreeForm.get('distributionsPricePerShare').markAsPristine();

    this.stepThreeForm.get('distributionsTotalPrice').setValue('');
    this.stepThreeForm.get('distributionsTotalPrice').clearValidators();
    this.stepThreeForm.get('distributionsTotalPrice').updateValueAndValidity();
    this.stepThreeForm.get('distributionsTotalPrice').markAsUntouched();
    this.stepThreeForm.get('distributionsTotalPrice').markAsPristine();

    this.showMessage = false;
    this.clicked = false;

    /* (<FormArray>this.stepThreeForm.get('purchases')).push(this.newPurchase());*/
  }

  clearSalesData() {
    this.stepThreeForm.get('salesTradeDate').setValue('');
    this.stepThreeForm.get('salesTradeDate').clearValidators();
    this.stepThreeForm.get('salesTradeDate').updateValueAndValidity();
    this.stepThreeForm.get('salesTradeDate').markAsUntouched();
    this.stepThreeForm.get('salesTradeDate').markAsPristine();

    this.stepThreeForm.get('salesQuantity').setValue('');
    this.stepThreeForm.get('salesQuantity').clearValidators();
    this.stepThreeForm.get('salesQuantity').updateValueAndValidity();
    this.stepThreeForm.get('salesQuantity').markAsUntouched();
    this.stepThreeForm.get('salesQuantity').markAsPristine();

    this.stepThreeForm.get('salesCusip').setValue('');
    this.stepThreeForm.get('salesCusip').clearValidators();
    this.stepThreeForm.get('salesCusip').updateValueAndValidity();
    this.stepThreeForm.get('salesCusip').markAsUntouched();
    this.stepThreeForm.get('salesCusip').markAsPristine();

    this.stepThreeForm.get('salesPricePerShare').setValue('');
    this.stepThreeForm.get('salesPricePerShare').clearValidators();
    this.stepThreeForm.get('salesPricePerShare').updateValueAndValidity();
    this.stepThreeForm.get('salesPricePerShare').markAsUntouched();
    this.stepThreeForm.get('salesPricePerShare').markAsPristine();

    this.stepThreeForm.get('salesTotalPrice').setValue('');
    this.stepThreeForm.get('salesTotalPrice').clearValidators();
    this.stepThreeForm.get('salesTotalPrice').updateValueAndValidity();
    this.stepThreeForm.get('salesTotalPrice').markAsUntouched();
    this.stepThreeForm.get('salesTotalPrice').markAsPristine();

    this.showMessage = false;

  }

  addSalesData() {
    this.clicked = true;
    this.stepThreeForm.get('salesTradeDate')?.setValidators([Validators.required]);
    this.stepThreeForm.get('salesTradeDate')?.updateValueAndValidity();

    this.stepThreeForm.get('salesQuantity')?.setValidators([Validators.required, Validators.maxLength(11), Validators.pattern("\\d{0,6}(?:[.]\\d{1,4})?$")]);
    this.stepThreeForm.get('salesQuantity')?.updateValueAndValidity();

    this.stepThreeForm.get('salesCusip')?.setValidators([Validators.required]);
    this.stepThreeForm.get('salesCusip')?.updateValueAndValidity();

    this.stepThreeForm.get('salesPricePerShare')?.setValidators(Validators.compose([Validators.required, Validators.maxLength(11), Validators.pattern("\\d{0,6}(?:[.]\\d{1,4})?$")]));
    this.stepThreeForm.get('salesPricePerShare')?.updateValueAndValidity();

    this.stepThreeForm.get('salesTotalPrice')?.setValidators(Validators.compose([Validators.required, Validators.maxLength(11), Validators.pattern("\\d{0,6}(?:[.]\\d{1,4})?$")]));
    this.stepThreeForm.get('salesTotalPrice')?.updateValueAndValidity();

    if (this.stepThreeForm.get('salesTradeDate').invalid || this.stepThreeForm.get('salesQuantity').invalid || this.stepThreeForm.get('salesCusip').invalid 
      || this.stepThreeForm.get('salesPricePerShare').invalid || this.stepThreeForm.get('salesTotalPrice').invalid) {
      return;
    }

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    };

    let tradeDate = this.stepThreeForm.get('salesTradeDate').value.toLocaleDateString("en-us", options);
    let sl = new Array();

    sl = [{
      TradeType: 'S',
      SecurityType: 'Trust Certificate',
      TradeDate: tradeDate,
      Quantity: this.stepThreeForm.get('salesQuantity').value,
      Cusip: this.stepThreeForm.get('salesCusip').value,
      PricePerShare: this.stepThreeForm.get('salesPricePerShare').value,
      TotalPrice: this.stepThreeForm.get('salesTotalPrice').value,
    }];

    for (let i = 0; i < sl.length; i++) {
      this.saleList.push(sl[i]);
    }
    this.stepThreeForm.get('salesTradeDate').setValue('');
    this.stepThreeForm.get('salesTradeDate').clearValidators();
    this.stepThreeForm.get('salesTradeDate').updateValueAndValidity();
    this.stepThreeForm.get('salesTradeDate').markAsUntouched();
    this.stepThreeForm.get('salesTradeDate').markAsPristine();

    this.stepThreeForm.get('salesQuantity').setValue('');
    this.stepThreeForm.get('salesQuantity').clearValidators();
    this.stepThreeForm.get('salesQuantity').updateValueAndValidity();
    this.stepThreeForm.get('salesQuantity').markAsUntouched();
    this.stepThreeForm.get('salesQuantity').markAsPristine();

    this.stepThreeForm.get('salesCusip').setValue('');
    this.stepThreeForm.get('salesCusip').clearValidators();
    this.stepThreeForm.get('salesCusip').updateValueAndValidity();
    this.stepThreeForm.get('salesCusip').markAsUntouched();
    this.stepThreeForm.get('salesCusip').markAsPristine();

    this.stepThreeForm.get('salesPricePerShare').setValue('');
    this.stepThreeForm.get('salesPricePerShare').clearValidators();
    this.stepThreeForm.get('salesPricePerShare').updateValueAndValidity();
    this.stepThreeForm.get('salesPricePerShare').markAsUntouched();
    this.stepThreeForm.get('salesPricePerShare').markAsPristine();

    this.stepThreeForm.get('salesTotalPrice').setValue('');
    this.stepThreeForm.get('salesTotalPrice').clearValidators();
    this.stepThreeForm.get('salesTotalPrice').updateValueAndValidity();
    this.stepThreeForm.get('salesTotalPrice').markAsUntouched();
    this.stepThreeForm.get('salesTotalPrice').markAsPristine();

    this.showMessage = false;
    this.clicked = false;

    /* (<FormArray>this.stepThreeForm.get('purchases')).push(this.newPurchase());*/
  }

  clearClosingsData() {
    this.stepThreeForm.get('closingQuantity').setValue('');
    this.stepThreeForm.get('closingQuantity').clearValidators();
    this.stepThreeForm.get('closingQuantity').updateValueAndValidity();
    this.stepThreeForm.get('closingQuantity').markAsUntouched();
    this.stepThreeForm.get('closingQuantity').markAsPristine();

    this.stepThreeForm.get('closingCusip').setValue('');
    this.stepThreeForm.get('closingCusip').clearValidators();
    this.stepThreeForm.get('closingCusip').updateValueAndValidity();
    this.stepThreeForm.get('closingCusip').markAsUntouched();
    this.stepThreeForm.get('closingCusip').markAsPristine();

    this.showMessage = false;

  }

  addClosingsData() {
    this.clicked = true;

    this.stepThreeForm.get('closingQuantity')?.setValidators([Validators.required, Validators.maxLength(12), Validators.pattern("^-?((\\d{0,6}\\.\\d{1,4})|(\\d{1,6}))$")]);
    this.stepThreeForm.get('closingQuantity')?.updateValueAndValidity();

    this.stepThreeForm.get('closingCusip')?.setValidators([Validators.required]);
    this.stepThreeForm.get('closingCusip')?.updateValueAndValidity();

    if (this.stepThreeForm.get('closingQuantity').invalid || this.stepThreeForm.get('closingCusip').invalid ) {
      return;
    }

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    };

    let cl = new Array();

    cl = [{
      TradeType: 'C',
      SecurityType: 'Trust Certificate',
      Quantity: this.stepThreeForm.get('closingQuantity').value,
      Cusip: this.stepThreeForm.get('closingCusip').value,
    }];

    for (let i = 0; i < cl.length; i++) {
      this.closingList.push(cl[i]);
    }
    this.stepThreeForm.get('closingQuantity').setValue('');
    this.stepThreeForm.get('closingQuantity').clearValidators();
    this.stepThreeForm.get('closingQuantity').updateValueAndValidity();
    this.stepThreeForm.get('closingQuantity').markAsUntouched();
    this.stepThreeForm.get('closingQuantity').markAsPristine();

    this.stepThreeForm.get('closingCusip').setValue('');
    this.stepThreeForm.get('closingCusip').clearValidators();
    this.stepThreeForm.get('closingCusip').updateValueAndValidity();
    this.stepThreeForm.get('closingCusip').markAsUntouched();
    this.stepThreeForm.get('closingCusip').markAsPristine();

    this.showMessage = false;
    this.clicked = false;

    /* (<FormArray>this.stepThreeForm.get('purchases')).push(this.newPurchase());*/
  }

  removePurchasesRow(i: number) {
    this.purchaseList.splice(i, 1);
  }

  removeDistributionsRow(i: number) {
    this.distributionList.splice(i, 1);
  }

  removeSalesRow(i: number) {
    this.saleList.splice(i, 1);
  }

  removeClosingsRow(i: number) {
    this.closingList.splice(i, 1);
  }

  getFileDetails(e) {

    for (let i = 0; i < e.target.files.length; i++) {
      this.supportingDocuments.push(e.target.files[i]);
    }
  }

  removeRow(i: number) {
    this.supportingDocuments.splice(i, 1);
    this.fileInput.nativeElement.value = null;
  }

  get stepTwoData(): any {
    return this.dataService.stepTwoSharedData;
  }
  get stepFourData(): any {
    return this.dataService.stepFourSharedData;
  }


  get stepThreeDataPurchases(): any {
    return this.dataService.stepThreeSharedDataPurchases;
  }
  get stepThreeDataDistributions(): any {
    return this.dataService.stepThreeSharedDataDistributions;
  }
  get stepThreeDataSales(): any {
    return this.dataService.stepThreeSharedDataSales;
  }
  get stepThreeDataClosing(): any {
    return this.dataService.stepThreeSharedDataClosing;
  }

  buildClaimDetailList(newList: any) {
    for (let i = 0; i < newList.length; i++) {
      this.claimDetailList.push(newList[i]);
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.stepFiveForm.invalid) {
      return;
    }
    this.submitClicked = true;
    this.clicked = true;
    const claimant = this.stepFiveForm.value;
    this.dateLoaded = new Date();
    this.claimEndTime = this.dateLoaded.toLocaleTimeString();

    this.buildClaimDetailList(this.stepThreeDataPurchases);
    this.buildClaimDetailList(this.stepThreeDataDistributions);
    this.buildClaimDetailList(this.stepThreeDataSales);
    this.buildClaimDetailList(this.stepThreeDataClosing);

    claimant.name1 = this.stepTwoData.name1;
    claimant.name2 = this.stepTwoData.name2;
    claimant.name3 = this.stepTwoData.name3;
    claimant.name4 = this.stepTwoData.name4;
    claimant.emailAddress = this.stepTwoData.emailAddress;
    claimant.street1 = this.stepTwoData.street1;
    claimant.street2 = this.stepTwoData.street2;
    claimant.city = this.stepTwoData.city;
    claimant.state = this.stepTwoData.state;
    claimant.country = this.stepTwoData.country;
    claimant.province = this.stepTwoData.province;
    claimant.postalCode = this.stepTwoData.postalCode;
    claimant.zip = this.stepTwoData.zip;
    claimant.primaryPhone = this.stepTwoData.primaryPhone;
    claimant.secondaryPhone = this.stepTwoData.secondaryPhone;
    claimant.primaryPhoneType = this.stepTwoData.primaryPhoneType;
    claimant.secondaryPhoneType = this.stepTwoData.secondaryPhoneType;
    claimant.claimantAccountType = this.stepTwoData.claimantAccountType;
    claimant.otherClaimantAccountType = this.stepTwoData.otherClaimantAccountType;
    claimant.claimDetail = this.claimDetailList;
    claimant.last4SSN = this.stepTwoData.last4SSN;
    claimant.tin = this.stepTwoData.tin;
    claimant.accountNumber = this.stepTwoData.accountNumber;
    claimant.irsBackupWitholding = this.stepFiveForm.get('irsBackUpWithHolding')?.value;
    claimant.signature = this.stepFiveForm.get('signature').value;
    claimant.jointClaimantSignature = this.stepFiveForm.get('jointClaimantSignature').value;
    claimant.signingOnBehalfCapacity = this.stepFiveForm.get('signingOnBehalfCapacity').value;
    claimant.helperCapacity = this.stepFiveForm.get('helperCapacity').value;
    claimant.googleRecaptchaToken = this.stepFiveForm.get('googleRecaptchaToken').value;
    claimant.claimStartTime = this.claimStartTime;
    claimant.claimEndTime = this.claimEndTime;

    this.spinner.show();
    this.CreateClaimant(claimant);
  }



  CreateClaimant(claimant: Claimant) {
    const message = "Unable to save claimant data.";
    this.claimantService.createClaimant(claimant).subscribe(res => {
      this.submittedClaim = res;
      if (this.submittedClaim.statusMessage === message) {
        this.showSubmittalErrorWarning = true;
        return;
      }
      this.SubmitDocuments(this.submittedClaim.claimNumber);
    });
  }

  SubmitDocuments(claimNumber: string) {
    this.claimantService.submitDocuments(this.submittedClaim.claimNumber, this.stepFourData).subscribe(() => {
    });
    this.storage.store('claimant', this.submittedClaim);
    // this.dataSaved = true;
    // this.submitted = false;
    // this.notSubmitted = false;
    // this.message = "Record Saved Successfully";
    this.stepFiveForm.reset();
    this.spinner.hide();
    this.router.navigate(['/complete']);
  }
}
